import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreLoader = _resolveComponent("PreLoader")!
  const _component_ThemeSwitcher = _resolveComponent("ThemeSwitcher")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PreLoader),
    _createVNode(_component_ThemeSwitcher),
    _createVNode(_component_router_view),
    _createVNode(_component_BackToTop)
  ], 64))
}